
import * as angular from "angular";
import { IForm } from "./IForm";
import { IKeyValuePair } from "@interfaces/IKeyValuePair";

export class FormBuilderService {

    static $inject = ["$http"];

    constructor(
        private readonly $http: angular.IHttpService) {
    }

    getForms(): angular.IPromise<IForm[]> {
        return this.$http(
                {
                    method: "GET",
                    url: "/api/forms",
                })
            .then((response: angular.IHttpPromiseCallbackArg<IForm[]>) => {
                return response.data;
            });
    }

    // hard-coded list - not currently definitive list - see CFG_Form_FieldType table
    // will need to be changed to read values from Sql table at some point
    getFieldTypes(): IKeyValuePair[] {

        const fieldTypes = [] as IKeyValuePair[];

        fieldTypes.push({ value: "25", name: "Automatic" });
        fieldTypes.push({ value: "3", name: "Checkbox" });
        fieldTypes.push({ value: "6", name: "Combo" });
        fieldTypes.push({ value: "16", name: "Customer Vehicle Check" });
        fieldTypes.push({ value: "11", name: "Date Picker" });
        fieldTypes.push({ value: "21", name: "Date Stamp" });
        fieldTypes.push({ value: "7", name: "Input" });
        fieldTypes.push({ value: "13", name: "Input Camera" });
        fieldTypes.push({ value: "14", name: "Input Image" });
        fieldTypes.push({ value: "20", name: "Location Stamp" });
        fieldTypes.push({ value: "4", name: "Radio Group" });
        fieldTypes.push({ value: "15", name: "Signature Pad" });
        fieldTypes.push({ value: "5", name: "Switch" });
        fieldTypes.push({ value: "12", name: "Time Picker" });

        return fieldTypes;
    }

    getAutoDataFields(): IKeyValuePair[] {
        const fieldTypes = [] as IKeyValuePair[];

        fieldTypes.push({ value: "1", name: "Job Id" });
        fieldTypes.push({ value: "2", name: "Job Name" });
        fieldTypes.push({ value: "3", name: "Job Vehicle Name" });
        fieldTypes.push({ value: "4", name: "Job Vehicle Registration" });

        return fieldTypes;
    }

    updateForm(formItem: IForm): angular.IPromise<boolean> {
        return this.$http(
                {
                    method: "POST",
                    url: "/api/updateForm",
                    data: formItem
                })
            .then((response: angular.IHttpPromiseCallbackArg<boolean>) => {
                return response.data;
            });
    }

    addForm(form: IForm): angular.IPromise<boolean> {
        return this.$http(
                {
                    method: "POST",
                    url: "/api/addForm",
                    data: form

                })
            .then((response: angular.IHttpPromiseCallbackArg<boolean>) => {
                return response.data;
            });
    }

    removeForm(form: IForm): angular.IPromise<boolean> {
        return this.$http(
                {
                    method: "POST",
                    url: "/api/removeForm",
                    data: form
                })
            .then((response: angular.IHttpPromiseCallbackArg<boolean>) => {
                return response.data;
            });
    }

    getFormTypes(enableJobCompletionType = true): IKeyValuePair[] {
        const formTypes = [] as IKeyValuePair[];

        formTypes.push({ value: "0", name: "Vehicle Checks" });
        formTypes.push({ value: "1", name: "Other Forms" });
        formTypes.push({ value: "2", name: "Jobs" });

        if (enableJobCompletionType) {
            formTypes.push({ value: "3", name: "Job Completion" });
        }

        return formTypes;
    }
}
